import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import axios from "axios";
// import footerLogo1 from "./full logo- white.avif";
import { Drawer, Spin, Button, Input, Switch } from "antd";

// import backgroundimg from "./background2.avif";
import Swal from "sweetalert2";
import { JSON_BASE_URL } from "../Config/Config";

const FILE_UPLOAD_URL = `${JSON_BASE_URL}/ibiz-upload`;

const extractYoutubeVideoId = (url = "") => {
  if (!url) return "";

  try {
    const parsedUrl = new URL(url);

    if (parsedUrl.searchParams.get("v")) {
      return parsedUrl.searchParams.get("v");
    }

    const pathSegments = parsedUrl.pathname.split("/").filter(Boolean);
    return pathSegments[pathSegments.length - 1] || "";
  } catch (error) {
    return "";
  }
};

const buildYoutubeEmbedUrl = (url = "") => {
  if (!url) return "";

  try {
    const parsedUrl = new URL(url);

    if (parsedUrl.pathname.includes("/embed/videoseries")) {
      const playlistId = parsedUrl.searchParams.get("list");
      if (!playlistId) return url;

      return `https://www.youtube.com/embed/videoseries?list=${playlistId}&autoplay=1&mute=1&loop=1&controls=1&rel=0&modestbranding=1`;
    }

    const videoId = extractYoutubeVideoId(url);
    if (!videoId) return url;

    return `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}&controls=1&rel=0&modestbranding=1`;
  } catch (error) {
    return url;
  }
};
const IbizLoginPage = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const navigate = useNavigate();
  const route = all_routes;

  const [featureCards, setFeatureCards] = useState([]);
  const [dataloading, setdataloading] = useState(false);
  const [featureCarouselSlides, setFeatureCarouselSlides] = useState([]);
  const [phoneSection, setPhoneSection] = useState({});
  const [activePhoneView, setActivePhoneView] = useState(0);

  const phoneViews = ["youtube", "linkedin", "instagram"];
  const activePhoneViewName = phoneViews[activePhoneView];

  const [topbar, setTopBar] = useState({});

  console.log(topbar, "topbar");

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [activeSection, setActiveSection] = useState(null);
  const [formData, setFormData] = useState({});
  const [pageData, setPageData] = useState({});
  const [uploading, setUploading] = useState(false);

  const [activeIndex, setActiveIndex] = useState(null);

  const handleEditSection = (sectionName, data, index = null) => {
    setActiveSection(sectionName);
    setFormData(data);
    setActiveIndex(index);
    setIsDrawerOpen(true);
  };

  const handleContactChange = (index, field, value) => {
    const updatedContact = [...formData.contact];

    updatedContact[index] = {
      ...updatedContact[index],
      [field]: value,
    };

    // 🔥 auto-update label if phone link changes
    if (updatedContact[index].type === "phone" && field === "link") {
      updatedContact[index].label = value.replace("tel:", "");
    }

    setFormData({
      ...formData,
      contact: updatedContact,
    });
  };

  const handleSocialChange = (index, field, value) => {
    const updatedSocial = [...formData.social];

    updatedSocial[index] = {
      ...updatedSocial[index],
      [field]: value,
    };

    setFormData({
      ...formData,
      social: updatedSocial,
    });
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setActivePhoneView((prev) => (prev + 1) % phoneViews.length);
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setdataloading(true);
      try {
        const res = await axios.get(`${JSON_BASE_URL}/ibiz-content`);
        const data = res.data;

        setPageData(data); // ✅ important
        console.log(data, "data.............");
        setTopBar(data.topbar || {});
        setFeatureCards(data.cards || []);
        setFeatureCarouselSlides(data.carousel || []);
        setPhoneSection(data.phoneSection || {});
      } catch (error) {
        console.error("Error fetching content:", error);
      } finally {
        setdataloading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (!featureCarouselSlides.length) return;

    const intervalId = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % featureCarouselSlides.length);
    }, 3000);

    return () => clearInterval(intervalId);
  }, [featureCarouselSlides]);

  useEffect(() => {
    if (window.instgrm) {
      window.instgrm.Embeds.process();
    }
  }, [activePhoneViewName, phoneSection.instagram?.embedUrl]);

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    if (token) {
      navigate(route.rollcalldashboard, { replace: true });
    }
  }, []);

  const handleSave = async () => {
    if (uploading) {
      Swal.fire({
        title: "Please wait",
        text: "Image is still uploading",
        icon: "warning",
      });
      return;
    }
    try {
      let updatedData = { ...pageData };

      if (activeSection === "titleSection") {
        updatedData.titleSection = {
          ...pageData.titleSection,
          ...formData,
        };
      } else if (activeSection === "topbar") {
        updatedData.topbar = {
          contact: (formData.contact || []).map((item, index) => ({
            ...pageData.topbar.contact[index], // ✅ keep old values
            ...item,
          })),
          social: (formData.social || []).map((item, index) => ({
            ...pageData.topbar.social[index], // ✅ keep old values
            ...item,
          })),
        };
      } else if (activeSection === "phoneSection") {
        updatedData.phoneSection = {
          ...pageData.phoneSection,
          ...formData,
        };
      } else if (activeSection === "featureCards") {
        updatedData.featureCards = [...formData];
      }

      if (activeSection === "carousel") {
        updatedData.carousel = formData.map((item, index) => ({
          ...item,
          order: index + 1,
        }));
      } else if (activeSection === "cards") {
        updatedData.cards = [...formData];
      } else if (activeSection === "card") {
        const updatedCards = [...pageData.cards];
        updatedCards[activeIndex] = {
          ...updatedCards[activeIndex],
          ...formData,
        };
        updatedData.cards = updatedCards;
      }

      setPageData(updatedData);
      console.log("FINAL PAYLOAD →", updatedData); // 🔥 DEBUG

      await axios.post(`${JSON_BASE_URL}/ibiz-content`, updatedData);

      setIsDrawerOpen(false);

      // ✅ Swal Success Popup
      Swal.fire({
        title: "Success!",
        text: "Content updated successfully",
        icon: "success",
        confirmButtonText: "OK",
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.reload(); // 🔄 reload page
        }
      });
    } catch (error) {
      console.error("Error saving:", error);

      // ❌ Error Popup
      Swal.fire({
        title: "Error!",
        text: "Something went wrong",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const handleImageUpload = async (event, config) => {
    const file = event.target.files?.[0];
    if (!file) return;


    if (file.size > 2 * 1024 * 1024) {
      alert("Image size should be less than 2 MB");
      event.target.value = "";
      return;
    }
    setUploading(true);
    console.log("checking......................1");

    const previewUrl = URL.createObjectURL(file);

    updateImage(previewUrl, config);

    const formDataUpload = new FormData();
    formDataUpload.append("file", file);
    formDataUpload.append("superid", "10000");
    formDataUpload.append("type", "ibiz");
    formDataUpload.append("product", "ibiz");

    try {
      console.log("checking......................2");

      const response = await axios.post(FILE_UPLOAD_URL, formDataUpload);
      console.log("checking......................3");

      const rawPath =
        response?.data?.path ||
        response?.data?.url ||
        response?.data?.data?.path ||
        response?.data?.data?.url;

      if (!rawPath) throw new Error("Image path missing");

      const imagePath = rawPath.startsWith("http")
        ? rawPath
        : `https://files-test.perennialdevelopers.in${rawPath}`;

      // 🔥 3. replace blob with real URL
      updateImage(imagePath, config);
      console.log("checking......................4");
    } catch (err) {
      console.error("Upload failed:", err);
    } finally {
      setUploading(false); // ✅ allow save
      event.target.value = "";
    }
  };

  const updateImage = (imagePath, config) => {
    // 👉 carousel (array)
    if (config.section === "carousel") {
      setFormData((prev) => {
        const updated = [...prev];
        updated[config.index] = {
          ...updated[config.index],
          image: imagePath,
        };
        return updated;
      });
    }

    // 👉 cards → single card (object)
    else if (config.section === "cards" && !Array.isArray(formData)) {
      setFormData((prev) => ({
        ...prev,
        image: imagePath,
      }));
    }

    // 👉 cards → multiple cards (array)
    else if (config.section === "cards" && Array.isArray(formData)) {
      setFormData((prev) => {
        const updated = [...prev];
        updated[config.index] = {
          ...updated[config.index],
          image: imagePath,
        };
        return updated;
      });
    }
  };

  const limits = {
    title: 40,
    description: 120,
  };

  const [activeTabCarosuel, setActiveTabCarosuel] = useState(0);
  const item = formData[activeTabCarosuel];

  return (
    <>
      <style>
        {`
          .rollcall-signin-page,
          .rollcall-signin-page * {
            box-sizing: border-box;
          }

        .rollcall-signin-page {
  width: 100%;
  height:100%;
   min-height: 100dvh;   /* allow growth */
  padding: 10px;
  background:
    radial-gradient(circle at top left, rgba(65, 113, 200, 0.14), transparent 28%),
    radial-gradient(circle at right center, rgba(105, 176, 255, 0.18), transparent 24%),
    linear-gradient(180deg, #eef2fa 0%, #f8faff 100%);
  
  display: flex;
  align-items: center;
  justify-content: center;

  overflow-x: hidden;   /* only hide horizontal */
}
          .rollcall-signin-shell {
            width: min(1300px, calc(100vw - 20px));
            max-width: 100%;
            min-height: 650px;      /* base height */
  height: auto;   
            max-height: calc(100dvh - 20px);
            border-radius: 28px;
            overflow: hidden;
            display: grid;
            grid-template-columns: minmax(350px, 360px) minmax(0, 1fr);
            background: rgba(255, 255, 255, 0.64);
           

            box-shadow: 0 28px 80px rgba(45, 77, 140, 0.18);
            backdrop-filter: blur(10px);
          }

          // .rollcall-auth-pane {
          //   position: relative;
          //   height: 100%;
          //   padding: 18px 20px;
          //   background:
          //     rgba(18, 58, 120, 0.38),
          //     url("assets/img/emile-perron-xrVDYZRGdw4-unsplash.jpg") center/cover;
          //   color: #fff;
          //   display: flex;
          //   flex-direction: column;
          //   justify-content: center;
          //   overflow: hidden;
          // }

          // .rollcall-auth-pane::before {
          //   content: "";
          //   position: absolute;
          //   inset: 0;
          //   background:
          //     radial-gradient(circle at 20% 90%, rgba(121, 190, 255, 0.26), transparent 30%),
          //     radial-gradient(circle at 85% 18%, rgba(255, 255, 255, 0.12), transparent 18%);
          //   pointer-events: none;
          // }
          .rollcall-auth-pane {
            position: relative;
            height: 100%;
            padding: 18px 20px;
          
            /* 🔥 Orange overlay + image */
            // background: linear-gradient(
            //   135deg,
            //   #ffffff 20%,
            //   #fdd9cc 50%,
            //   #DA3F0C 100%
            // );
              url("assets/img/emile-perron-xrVDYZRGdw4-unsplash.jpg") center/cover;
          
            color: #fff;
            display: flex;
            flex-direction: column;
            justify-content: center;
            overflow: hidden;
          }
          
          .rollcall-auth-pane::before {
            content: "";
            position: absolute;
            inset: 0;
          
            /* ✨ Orange glow gradients */
            // background:
            //   radial-gradient(circle at 20% 90%, rgba(255, 165, 0, 0.35), transparent 35%),
            //   radial-gradient(circle at 85% 18%, rgba(255, 200, 120, 0.25), transparent 25%);
          
            pointer-events: none;
          }

          .rollcall-auth-content,
          .rollcall-auth-brand {
            position: relative;
            z-index: 1;
          }

          .rollcall-auth-content {
            max-width: 320px;
            margin: 0 auto;
            width: 100%;
            display: flex;
            justify-content: center;
          }

          .rollcall-auth-content > .rollcall-auth-card {
            display: none;
          }

          .rollcall-auth-brand img {
            width: min(176px, 100%);
            display: block;
            margin: 0 auto;
          }

          .rollcall-auth-card {
            margin-top: 16px;
            padding: 16px 15px 15px;
            border-radius: 20px 20px 70px 20px;
            background: linear-gradient(180deg, rgba(5, 35, 80, 0.88), rgba(11, 58, 125, 0.92));
            border: 1px solid rgba(255, 255, 255, 0.14);
            box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08);
            backdrop-filter: blur(12px);
          }

          .rollcall-auth-card--showcase {
            width: 100%;
            max-width: 360px;
            margin: 0 auto;
          }

          .rollcall-auth-card h1 {
            margin: 0 0 8px;
            font-size: 18px;
            line-height: 1.2;
            font-weight: 800;
            color: #ffffff;
          }

          .rollcall-auth-card p {
            margin: 0 0 14px;
            font-size: 12px;
            color: rgba(255, 255, 255, 0.8);
          }

          .rollcall-form-group {
            margin-bottom: 10px;
          }

          .rollcall-input {
            display: flex;
            align-items: center;
            min-height: 38px;
            border: 1px solid rgba(255, 255, 255, 0.16);
            border-radius: 12px;
            background: rgba(104, 151, 224, 0.2);
            transition: border-color 0.2s ease, box-shadow 0.2s ease;
          }

          .rollcall-input:focus-within {
            border-color: rgba(152, 213, 255, 0.72);
            box-shadow: 0 0 0 3px rgba(102, 190, 255, 0.16);
          }

          .rollcall-input i {
            padding-left: 14px;
            font-size: 14px;
            color: rgba(255, 255, 255, 0.82);
          }

          .rollcall-input input {
            width: 100%;
            border: 0;
            outline: 0;
            background: transparent;
            color: #ffff;
            font-size: 13px;
            padding: 9px 10px 9px 8px;
          }

          .rollcall-input input::placeholder {
            color: rgba(255, 255, 255, 0.75);
          }

          .rollcall-password-toggle {
            padding-right: 14px;
            cursor: pointer;
            font-size: 14px;
          }

          .rollcall-form-row {
            margin: 8px 0 14px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 12px;
            color: rgba(255, 255, 255, 0.88);
            font-size: 13px;
          }

          .rollcall-checkbox {
            display: inline-flex;
            align-items: center;
            gap: 10px;
          }

          .rollcall-checkbox input {
            width: 18px;
            height: 18px;
            accent-color: #68adff;
          }

          .rollcall-forgot {
            color: rgba(255, 255, 255, 0.88);
            text-decoration: none;
          }

          .rollcall-forgot:hover {
            color: #ffffff;
          }

          .rollcall-login-btn {
            width: 100%;
            border: 0;
            border-radius: 12px;
            padding: 11px 16px;
            background: linear-gradient(180deg, #4ea5ff 0%, #1d74f6 100%);
            color: #ffffff;
            font-size: 14px;
            font-weight: 800;
            letter-spacing: 0.08em;
            box-shadow: 0 16px 32px rgba(30, 116, 246, 0.3);
          }

          .rollcall-login-btn:disabled {
            opacity: 0.7;
          }

          .rollcall-social-row {
            margin: 12px 0 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
          }

          .rollcall-social-icon {
            width: 34px;
            height: 34px;
            border-radius: 50%;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            font-size: 16px;
            text-decoration: none;
            box-shadow: 0 12px 24px rgba(3, 24, 64, 0.18);
          }

          .rollcall-social-icon.google {
            background: #ffffff;
            color: #ef4444;
          }

          .rollcall-social-icon.facebook {
            background: #1d74f6;
          }
              .rollcall-social-icon.instagram {
            background: #c97b9c;
          }

          .rollcall-social-icon.linkedin {
            background: #c7400b;
          }

          .rollcall-social-icon.twitter {
            background: #1da1f2;
          }

          .rollcall-beta-btn {
            width: 100%;
            min-height: 38px;
            border: 1px solid rgba(255, 255, 255, 0.24);
            border-radius: 12px;
            background: rgba(10, 28, 61, 0.22);
            color: #ffffff;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
            text-decoration: none;
            font-weight: 500;
            font-size: 12px;
          }

          .rollcall-contact-number1 {
            margin-top: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
            font-size: 12px;
            color: rgba(255, 255, 255, 0.92);
          }
                .rollcall-contact-number {
            margin-top: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
            font-size: 12px;
            color: rgba(255, 255, 255, 0.92);
          }

          .rollcall-showcase-pane {
            position: relative;
            height: 100%;
            padding: 26px 30px 24px;
            background: linear-gradient(
              135deg,
              #ffffff 20%,
              #fdd9cc 50%,
              #DA3F0C 100%
            );
            url("assets/img/backgroundimg2.jpg") center/cover;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            gap: 12px;
            overflow: hidden;
          }

          .rollcall-showcase-pane::before {
            content: "";
            position: absolute;
            inset: 0;
            background:
              linear-gradient(180deg, rgba(255, 255, 255, 0.28), rgba(255, 255, 255, 0.1)),
              radial-gradient(circle at 15% 25%, rgba(131, 189, 255, 0.18), transparent 20%),
              radial-gradient(circle at 88% 15%, rgba(151, 196, 255, 0.22), transparent 24%);
              
            pointer-events: none;
          }

          .rollcall-showcase-content {
            position: relative;
            z-index: 1;
            width: 100%;
            padding: 0 6px;
          }

          .rollcall-topbar {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            flex-wrap: wrap;
            gap: 12px;
            margin-bottom: 18px;
            color: #17335c;
            font-size: 14px;
          }

          .rollcall-topbar-item {
            display: inline-flex;
            align-items: center;
            gap: 8px;
            color: #17335c;
          }

          .rollcall-divider {
            width: 1px;
            height: 20px;
            background: rgba(23, 51, 92, 0.16);
          }

          .rollcall-topbar-social {
            display: inline-flex;
            gap: 10px;
          }

          .rollcall-topbar-social a {
            width: 26px;
            height: 26px;
            border-radius: 50%;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            text-decoration: none;
            color: #ffffff;
          }

           .rollcall-topbar-social .facebook {
            background: #2563eb;
          }

          .rollcall-topbar-social .youtube {
            background: #c7400b;
          }
                  .rollcall-topbar-social .instagram {
            background: #c97b9c;
          }

          .rollcall-topbar-social .twitter {
            background: #1da1f2;
          }

          .rollcall-showcase-title {
            margin: 0 0 10px;
            color: #0f274b;
            font-size: clamp(24px, 2.1vw, 38px);
            line-height: 1.12;
            font-weight: 800;
            max-width: 620px;
          }

          .rollcall-showcase-subtitle {
            margin: 0 0 18px;
            color: #263a5c;
            font-size: 15px;
            max-width: 620px;
          }

          .rollcall-feature-layout {
            display: grid;
            grid-template-columns: minmax(0, 1fr) 190px;
            gap: 16px;
            align-items: start;
            margin-bottom: 12px;
          }

          .rollcall-feature-grid {
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: 12px;
          }

          .rollcall-feature-card {
            min-height: 132px;
            border-radius: 16px;
            padding: 12px 14px;
            background: rgba(255, 255, 255, 0.86);
            border: 1px solid rgba(208, 223, 247, 0.8);
            box-shadow: 0 18px 34px rgba(74, 109, 173, 0.12);
            display: grid;
            grid-template-columns: 86px minmax(0, 1fr);
            gap: 10px;
            align-items: stretch;
            width: 100%;
          }

          .rollcall-feature-card.is-small {
            grid-template-columns: 80px minmax(0, 1fr);
          }

          .rollcall-feature-card.is-carousel {
            min-height: 146px;
          }

          .rollcall-feature-card.is-carousel .rollcall-feature-image img {
            max-height: 82px;
          }

          .rollcall-feature-body {
            min-width: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            gap: 10px;
          }

          .rollcall-feature-copy {
            min-width: 0;
          }

          .rollcall-feature-actions {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 12px;
            width: 100%;
          }

          .rollcall-phone-ad {
            position: relative;
            width: 225px;
            height: 390px;
            padding: 12px;
            border-radius: 38px;
            background: linear-gradient(180deg, #091a34 0%, #0b234b 100%);
            border: 2px solid rgba(255, 255, 255, 0.9);
            box-shadow: 0 28px 50px rgba(16, 43, 88, 0.26);
            margin-top: -74px;
          }

          .rollcall-phone-ad--auth {
            margin-top: 16px;
          }

          .rollcall-feature-layout > .rollcall-phone-ad {
            display: none;
          }

          .rollcall-phone-ad::before {
            content: "";
            position: absolute;
            top: 10px;
            left: 50%;
            transform: translateX(-50%);
            width: 84px;
            height: 9px;
            border-radius: 999px;
            background: rgba(255, 255, 255, 0.26);
          }

          .rollcall-phone-screen {
            height: 100%;
            border-radius: 30px;
            padding: 0;
            display: flex;
            flex-direction: column;
            overflow: hidden;
            color: #fff;
            background:
              linear-gradient(180deg, rgba(173, 186, 201, 0.96) 0%, rgba(83, 121, 177, 0.98) 100%),
              url("assets/img/backgroundimg2.jpg") center/cover;
          }

          .rollcall-phone-screen--content {
            padding: 14px 10px 10px;
            justify-content: space-between;
          }

          .rollcall-phone-screen--youtube,
          .rollcall-phone-screen--linkedin {
            background: #1b2026;
          }

          .rollcall-phone-stage {
            position: relative;
            width: 100%;
            height: 100%;
            min-height: 0;
          }

          .rollcall-phone-copy h4 {
            margin: 0 0 8px;
            font-size: 18px;
            line-height: 1.05;
            font-weight: 800;
          }

          .rollcall-phone-copy p {
            margin: 0;
            font-size: 11px;
            line-height: 1.45;
            color: rgba(255, 255, 255, 0.88);
          }

          .rollcall-phone-list {
            display: grid;
            gap: 6px;
            flex: 1;
            min-height: 0;
            overflow: hidden;
          }

          .rollcall-phone-list span {
            display: flex;
            align-items: center;
            gap: 6px;
            padding: 7px 9px;
            border-radius: 12px;
            background: rgba(9, 34, 77, 0.24);
            font-size: 10px;
            font-weight: 500;
          }

          .rollcall-phone-youtube {
            gap: 8px;
            height: 100%;
            width: 100%;
          }

          .rollcall-phone-youtube-player {
            height: 100%;
            overflow: hidden;
            background: #071120;
          }

          .rollcall-phone-youtube-player iframe {
            width: 100%;
            height: 100%;
            border: 0;
            display: block;
          }

          .rollcall-phone-linkedin {
            height: 100%;
            width: 100%;
          }

          .rollcall-feature-image {
            display: flex;
            align-items: center;
            justify-content: center;
            min-height: 100%;
          }

          .rollcall-feature-image img {
            width: 100%;
            max-height: 72px;
            object-fit: contain;
            filter: drop-shadow(0 12px 16px rgba(33, 61, 117, 0.12));
          }

          .rollcall-feature-text h3 {
            margin: 0 0 8px;
            color: #0f274b;
            font-size: clamp(15px, 1vw, 19px);
            line-height: 1.15;
            font-weight: 800;
          }

          .rollcall-feature-card.is-small .rollcall-feature-text h3 {
            font-size: clamp(14px, 0.92vw, 17px);
          }

          .rollcall-feature-text p {
            margin: 0;
            color: #2d466f;
            font-size: 12px;
            line-height: 1.35;
          }

          .rollcall-learn-btn {
            border: 0;
            border-radius: 10px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            color: blue;
            font-size: 15px;
            font-weight: 700;
            letter-spacing: 0.05em;
            text-decoration: none;
            margin-left: auto;
          }

          .rollcall-card-dots {
            display: flex;
            gap: 8px;
            margin-top: 0;
          }

          .rollcall-card-dots span {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: rgba(34, 116, 211, 0.22);
          }

          .rollcall-card-dots span.active {
            background: #2d86f6;
          }

          .rollcall-highlight-strip,
          .rollcall-bottom-strip {
            display: grid;
            align-items: center;
            gap: 12px;
            border-radius: 18px;
            background: rgba(255, 255, 255, 0.64);
            border: 1px solid rgba(208, 223, 247, 0.86);
            box-shadow: 0 16px 30px rgba(74, 109, 173, 0.08);
          }

          .rollcall-highlight-strip {
            grid-template-columns: repeat(3, minmax(0, 1fr));
            padding: 14px 18px;
          }

          .rollcall-bottom-strip {
            grid-template-columns: repeat(4, minmax(0, 1fr));
            margin-top: 0;
            padding: 12px 18px;
          }

          .rollcall-strip-item {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 12px;
            color: #17335c;
            font-size: 13px;
            text-align: center;
          }

          .rollcall-strip-item i {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            background: rgba(38, 117, 246, 0.12);
            color: #1f5ec9;
            font-size: 15px;
          }

          @media (max-width: 1199px) {
            .rollcall-signin-shell {
              grid-template-columns: minmax(300px, 340px) minmax(0, 1fr);
            }

            .rollcall-showcase-pane {
              padding: 22px 22px 18px;
            }

            .rollcall-feature-layout {
              grid-template-columns: 1fr;
            }

            .rollcall-feature-grid {
              grid-template-columns: 1fr;
            }

            .rollcall-phone-ad {
              width: min(205px, 100%);
              height: 292px;
              margin-top: 0;
              margin: 0 auto;
            }

            .rollcall-auth-card--showcase {
              max-width: 100%;
            }
          }

          @media (max-width: 991px) {
            .rollcall-signin-page {
              height: auto;
              min-height: 100dvh;
              padding: 12px;
              overflow: visible;
            }

            .rollcall-signin-shell {
              width: min(100%, calc(100vw - 24px));
              height: auto;
              max-height: none;
              grid-template-columns: 1fr;
            }

            .rollcall-auth-pane,
            .rollcall-showcase-pane {
              height: auto;
              overflow: visible;
              padding: 20px;
            }

            .rollcall-highlight-strip {
              grid-template-columns: 1fr;
            }

            .rollcall-bottom-strip {
              grid-template-columns: repeat(2, minmax(0, 1fr));
            }
            .signin-footer-content {
              grid-template-columns: 1fr;
              gap: 20px;
            }
          }

          @media (max-width: 767px) {
            .rollcall-signin-page {
              padding: 10px;
            }

            .rollcall-signin-shell {
              width: min(100%, calc(100vw - 20px));
              height: auto;
              border-radius: 22px;
            }

            .rollcall-auth-card h1 {
              font-size: 22px;
            }

            .rollcall-showcase-title {
              font-size: 28px;
            }

            .rollcall-topbar {
              justify-content: flex-start;
              margin-bottom: 24px;
            }

            .rollcall-divider {
              display: none;
            }

            .rollcall-feature-card,
            .rollcall-feature-card.is-small {
              grid-template-columns: 1fr;
              text-align: center;
            }

            .rollcall-feature-actions {
              justify-content: center;
            }

            .rollcall-phone-copy h4 {
              font-size: 20px;
            }

            .rollcall-feature-image img {
              max-width: 200px;
            }

            .rollcall-topbar-social {
              flex-wrap: wrap;
            }

            .rollcall-card-dots,
            .rollcall-strip-item {
              justify-content: center;
            }

            .rollcall-bottom-strip {
              grid-template-columns: 1fr;
            }

            .rollcall-form-row {
              flex-direction: column;
              align-items: flex-start;
            }
          }


          
.signin-footer {
  margin-top: 10px;
}

.signin-footer-main {
  padding: 40px 0 18px;
  background: linear-gradient(135deg, #bc1615, #e44c0a);
}

.signin-footer-grid {
  align-items: flex-start;
  row-gap: 24px;
}

.signin-footer-brand {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.signin-footer-logo {
  max-width: 240px;
}

.signin-footer-social {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
}

.signin-footer-social a,
.signin-footer-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.signin-footer-social a {
  width: 40px;
  height: 40px;
  border-radius: 999px;
  color: #fff;
  background: rgba(255, 255, 255, 0.14);
  text-decoration: none;
}

.signin-footer-address {
  display: inline-flex;
  align-items: flex-start;
  gap: 12px;
  color: #fff;
  text-decoration: none;
  line-height: 1.5;
}

.signin-footer-content {
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: 24px;
}

.signin-footer-title {
  margin: 0 0 12px;
  font-size: 1.1rem;
  font-weight: 700;
}

.signin-footer-contact {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.signin-footer-line {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin: 0;
  line-height: 1.5;
}

.signin-footer-email-list,
.signin-footer-links {
  margin: 0;
  padding: 0;
  list-style: none;
}

.signin-footer-links {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.signin-footer-links a {
  color: #fff;
  text-decoration: none;
}

.signin-footer-divider {
  margin: 24px 0 12px;
}

.signin-footer-copy {
  text-align: center;
  font-size: 0.85rem;
}


      
        
.logo-box {
  padding: 5px 40px;
  display: inline-block;
 
}


.menu-card {
  width: 110px;
  height: 110px;
  background: #fff;
  border-radius: 15px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  cursor: pointer;
}

.menu-card-body {
  text-align: center;
}

.menu-icon svg {
  width: 35px;
  height: 35px;
  stroke: #333;
  fill: none;
  transition: all 0.3s ease;
}

// .menu-card:hover {
//   transform: translateY(-6px) scale(1.05);
//   box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
 
// }



.menu-card h6 {
  font-size: 12px;
  margin-top: 8px;
}


@media (max-width: 1023px) and (min-width: 768px) {
  .rollcall-feature-grid {
    grid-template-columns: repeat(2, 1fr); /* 2 cards per row */
  }
}

/* 📱 Mobile */
@media (max-width: 767px) {
  .rollcall-feature-grid {
    grid-template-columns: 1fr; /* single column */
  }
}



        `}
      </style>

      <div className="pt-5">
        <div className="rollcall-signin-page mt-5">
          <div className="rollcall-signin-shell">
            <aside className="rollcall-auth-pane">
              <div className="rollcall-auth-brand">
                <Link to="/home">
                  <img src="assets/img/logo.png" alt="RollCall Attendance" />
                  {/* <h2 className="me-3">RC Admin Page</h2> */}
                </Link>
              </div>

              <div className="rollcall-auth-content">
                <div className="rollcall-phone-ad rollcall-phone-ad--auth">
                  <div
                    className={`rollcall-phone-screen ${
                      activePhoneViewName === "youtube"
                        ? "rollcall-phone-screen--youtube"
                        : "rollcall-phone-screen--linkedin"
                    }`}
                    style={{ position: "relative", minHeight: "200px" }}
                  >
                    {dataloading ? (
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          background: "rgba(255,255,255,0.6)",
                          zIndex: 10,
                        }}
                      >
                        <div className="text-center">
                          <Spin size="large" />
                          <p className="mt-2">Loading...</p>
                        </div>
                      </div>
                    ) : (
                      <>
                        {activePhoneViewName === "youtube" &&
                          phoneSection.youtube?.enabled &&
                          phoneSection.youtube?.embedUrl && (
                            <div className="rollcall-phone-stage rollcall-phone-youtube">
                              <div className="rollcall-phone-youtube-player">
                                <iframe
                                  src={buildYoutubeEmbedUrl(
                                    phoneSection.youtube.embedUrl
                                  )}
                                  title={
                                    phoneSection.youtube.title ||
                                    "Pereco India YouTube"
                                  }
                                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                  allowFullScreen
                                />
                              </div>
                            </div>
                          )}

                        {activePhoneViewName === "linkedin" &&
                          phoneSection.linkedin?.enabled &&
                          phoneSection.linkedin?.embedUrl && (
                            <div className="rollcall-phone-stage rollcall-phone-linkedin">
                              <div className="rollcall-phone-youtube-player">
                                <iframe
                                  src={phoneSection.linkedin.embedUrl}
                                  title={
                                    phoneSection.linkedin.title ||
                                    "LinkedIn Post"
                                  }
                                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                  allowFullScreen
                                />
                              </div>
                            </div>
                          )}

                        {activePhoneViewName === "instagram" &&
                          phoneSection.instagram?.enabled &&
                          phoneSection.instagram?.embedUrl && (
                            <div className="rollcall-phone-stage rollcall-phone-linkedin">
                              <div
                                style={{
                                  width: "100%",
                                  margin: "0 auto",
                                }}
                              >
                                <blockquote
                                  className="instagram-media"
                                  data-instgrm-permalink={
                                    phoneSection.instagram.embedUrl
                                  }
                                  data-instgrm-version="14"
                                  style={{ width: "100%" }}
                                ></blockquote>
                              </div>
                            </div>
                          )}

                        <div
                          className="section-header"
                          style={{
                            position: "absolute",
                            top: 10,
                            right: 10,
                            zIndex: 10,
                          }}
                        >
                          <i
                            className="ti ti-edit edit-icon fs-4"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              handleEditSection(
                                "phoneSection",
                                pageData?.phoneSection
                              )
                            }
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </aside>

            <section
              className="rollcall-showcase-pane"
              // style={{
              // //   background: `url(${backgroundimg}) center/cover no-repeat`,
              //   minHeight: "500px",
              //   position: "relative",
              // }}
            >
              {dataloading ? (
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "rgba(255,255,255,0.7)",
                    zIndex: 10,
                  }}
                >
                  <div className="text-center">
                    <Spin size="large" />
                    <p className="mt-2">Loading features...</p>
                  </div>
                </div>
              ) : (
                <>
                  <div className="rollcall-showcase-content">
                    <div className="rollcall-topbar">
                      {topbar?.contact
                        ?.filter((item) => item.visible) // ✅ only visible items
                        .map((item, index, arr) => (
                          <React.Fragment key={index}>
                            <div className="rollcall-topbar-item">
                              <i className={item.icon} />
                              <a href={item.link}>{item.label}</a>
                            </div>

                            {/* Divider only between visible items */}
                            {index !== arr.length - 1 && (
                              <div className="rollcall-divider" />
                            )}
                          </React.Fragment>
                        ))}

                      {/* Show divider only if both sections have visible items */}
                      {topbar?.contact?.some((i) => i.visible) &&
                        topbar?.social?.some((i) => i.visible) && (
                          <div className="rollcall-divider" />
                        )}

                      <div className="rollcall-topbar-social">
                        {topbar?.social
                          ?.filter((social) => social.visible) // ✅ filter here too
                          .map((social, index) => (
                            <a
                              key={index}
                              href={social.link}
                              className={social.Name}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <i className={social.icon} />
                            </a>
                          ))}
                      </div>

                      <div className="section-header">
                        <i
                          className="ti ti-edit edit-icon fs-4"
                          style={{ marginLeft: "10px", cursor: "pointer" }}
                          onClick={() =>
                            handleEditSection("topbar", pageData?.topbar)
                          }
                        />
                      </div>
                    </div>

                    <h2 className="rollcall-showcase-title">
                      {pageData?.titleSection?.title}

                      <i
                        className="ti ti-edit edit-icon fs-4"
                        style={{ marginLeft: "10px", cursor: "pointer" }}
                        onClick={() =>
                          handleEditSection(
                            "titleSection",
                            pageData?.titleSection
                          )
                        }
                      />
                    </h2>

                    <p className="rollcall-showcase-subtitle">
                      {pageData?.titleSection?.subtitle}
                    </p>

                    {/* <div className="rollcall-feature-layout">
                                            <div className="rollcall-feature-grid">
                                                {featureCards.map((item, index) => {
                                                    const isCarousel = index === 0;

                                                    const currentItem = isCarousel
                                                        ? featureCarouselSlides[activeSlide] || {}
                                                        : item;

                                                    return (
                                                        <article
                                                            key={index}
                                                            className={`rollcall-feature-card ${isCarousel ? "is-carousel" : ""
                                                                } ${item?.large ? "" : "is-small"}`}
                                                        >
                                                            <div className="rollcall-feature-image">
                                                                <img
                                                                    src={currentItem.image}
                                                                    alt={currentItem.title}
                                                                    loading="lazy"
                                                                />
                                                            </div>

                                                            <div className="rollcall-feature-body">
                                                                <div className="rollcall-feature-text rollcall-feature-copy">
                                                                    <h3>{currentItem.title}</h3>
                                                                    <p>{currentItem.description}</p>
                                                                </div>

                                                                <div className="rollcall-feature-actions">
                                                                    {isCarousel &&
                                                                        featureCarouselSlides.length > 0 && (
                                                                            <div className="rollcall-card-dots">
                                                                                {featureCarouselSlides.map(
                                                                                    (_, slideIndex) => (
                                                                                        <span
                                                                                            key={slideIndex}
                                                                                            className={
                                                                                                slideIndex === activeSlide
                                                                                                    ? "active"
                                                                                                    : ""
                                                                                            }
                                                                                        />
                                                                                    )
                                                                                )}
                                                                            </div>
                                                                        )}

                                                                    <div className="rollcall-feature-actions d-flex align-items-center gap-2">
                                                                        <Link
                                                                            to={currentItem?.link || "#"}
                                                                            className="rollcall-learn-btn"
                                                                        >
                                                                            <i className="ti ti-arrow-right" />
                                                                        </Link>

                                                                     
                                                                        <i
                                                                            className="ti ti-edit edit-icon "
                                                                            style={{
                                                                                cursor: "pointer",
                                                                                width: "25px",
                                                                            }}
                                                                            onClick={() =>
                                                                                isCarousel
                                                                                    ? handleEditSection(
                                                                                        "carousel",
                                                                                        pageData?.carousel
                                                                                    )
                                                                                    : handleEditSection(
                                                                                        "card",
                                                                                        pageData?.cards[index],
                                                                                        index
                                                                                    )
                                                                            }
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </article>
                                                    );
                                                })}
                                            </div>
                                        </div> */}

                    <div className="rollcall-feature-layout">
                      <div className="rollcall-feature-grid">
                        {featureCards.map((item, index) => (
                          <article
                            key={index}
                            className={`rollcall-feature-card ${
                              item?.large ? "" : "is-small"
                            }`}
                          >
                            <div className="rollcall-feature-image">
                              <img
                                src={item.image}
                                alt={item.title}
                                loading="lazy"
                              />
                            </div>

                            <div className="rollcall-feature-body">
                              <div className="rollcall-feature-text rollcall-feature-copy">
                                <h3>{item.title}</h3>

                                <p>{item.description}</p>
                              </div>

                              <div className="rollcall-feature-actions d-flex align-items-center gap-2">
                                <Link
                                  to={item?.link || "#"}
                                  className="rollcall-learn-btn"
                                >
                                  <i className="ti ti-arrow-right" />
                                </Link>

                                <i
                                  className="ti ti-edit edit-icon"
                                  style={{
                                    cursor: "pointer",
                                    width: "25px",
                                  }}
                                  onClick={() =>
                                    handleEditSection(
                                      "card",
                                      pageData?.cards[index],
                                      index
                                    )
                                  }
                                />
                              </div>
                            </div>
                          </article>
                        ))}
                      </div>
                      <div className="">
                        <div>
                          <h3>Carousel Section</h3>
                        </div>

                        {featureCarouselSlides.length > 0 && (
                          <div className="rollcall-big-carousel-card mt-5">
                            <img
                              src={featureCarouselSlides[activeSlide]?.image}
                              alt={featureCarouselSlides[activeSlide]?.title}
                              loading="lazy"
                              className="rollcall-big-carousel-image"
                            />

                            <div className="rollcall-big-carousel-overlay">
                              <div className="rollcall-big-carousel-footer">
                                <div className="rollcall-card-dots">
                                  {featureCarouselSlides.map(
                                    (_, slideIndex) => (
                                      <span
                                        key={slideIndex}
                                        className={
                                          slideIndex === activeSlide
                                            ? "active"
                                            : ""
                                        }
                                      />
                                    )
                                  )}
                                </div>

                                {/* Actions */}
                                <div className="d-flex align-items-center gap-2">
                                  <Link
                                    to={
                                      featureCarouselSlides[activeSlide]
                                        ?.link || "#"
                                    }
                                    className="rollcall-learn-btn"
                                  >
                                    <i className="ti ti-arrow-right" />
                                  </Link>

                                  <i
                                    className="ti ti-edit edit-icon"
                                    style={{
                                      cursor: "pointer",
                                      width: "25px",
                                    }}
                                    onClick={() =>
                                      handleEditSection(
                                        "carousel",
                                        pageData?.carousel
                                      )
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <h5></h5>
                      <i
                        className="ti ti-edit fs-4"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          handleEditSection(
                            "featureCards",
                            pageData?.featureCards
                          )
                        }
                      />
                    </div>

                    <div className="d-flex gap-3 flex-wrap border pt-2 pb-2">
                      {pageData?.featureCards?.map((item, index) => (
                        <div className="menu-card" key={index}>
                          <div className="menu-card-body text-center">
                            <div
                              className="menu-icon"
                              style={{ color: item.color }}
                              dangerouslySetInnerHTML={{ __html: item.svg }}
                            />
                            <h6 className="mt-2">{item.name}</h6>
                          </div>
                        </div>
                      ))}
                    </div>

                    <Drawer
                      title={`Edit ${activeSection}`}
                      placement="right"
                      width={450}
                      onClose={() => setIsDrawerOpen(false)}
                      open={isDrawerOpen}
                    >
                      {activeSection === "topbar" && (
                        <>
                          <h4>Contact</h4>
                          {formData.contact.map((item, index) => (
                            <div
                              key={index}
                              style={{
                                marginBottom: "15px",
                                border: "1px solid #ddd",
                                padding: "10px",
                                borderRadius: "6px",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  marginBottom: "8px",
                                }}
                              >
                                <i
                                  className={item.icon}
                                  style={{
                                    fontSize: "22px",
                                    color: item.color,
                                  }}
                                />

                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <label style={{ margin: 0 }}>Visible</label>
                                  <Switch
                                    size="small"
                                    checked={item.visible}
                                    onChange={(checked) =>
                                      handleContactChange(
                                        index,
                                        "visible",
                                        checked
                                      )
                                    }
                                  />
                                </div>
                              </div>
                              <div style={{ marginBottom: "8px" }}>
                                <label>Link</label>
                                <Input
                                  value={item.link}
                                  onChange={(e) =>
                                    handleContactChange(
                                      index,
                                      "link",
                                      e.target.value
                                    )
                                  }
                                />
                              </div>
                            </div>
                          ))}

                          <h4>Social</h4>
                          {formData.social.map((item, index) => (
                            <div
                              key={index}
                              style={{
                                marginBottom: "15px",
                                border: "1px solid #ddd",
                                padding: "10px",
                                borderRadius: "6px",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  marginBottom: "8px",
                                }}
                              >
                                <i
                                  className={item.icon}
                                  style={{
                                    fontSize: "22px",
                                    color: item.color,
                                  }}
                                />

                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <label style={{ margin: 0 }}>Visible</label>
                                  <Switch
                                    size="small"
                                    checked={item.visible}
                                    onChange={(checked) =>
                                      handleSocialChange(
                                        index,
                                        "visible",
                                        checked
                                      )
                                    }
                                  />
                                </div>
                              </div>
                              <div>
                                <label>Link</label>
                                <Input
                                  value={item.link}
                                  onChange={(e) =>
                                    handleSocialChange(
                                      index,
                                      "link",
                                      e.target.value
                                    )
                                  }
                                />
                              </div>
                            </div>
                          ))}
                        </>
                      )}

                      {activeSection === "phoneSection" && (
                        <>
                          {["youtube", "linkedin", "instagram"].map(
                            (platform) => {
                              const data = formData[platform] || {};

                              const limits = {
                                title: 40,
                                description: 120,
                                embedUrl: 200,
                              };

                              return (
                                <div
                                  key={platform}
                                  style={{
                                    border: "1px solid #ddd",
                                    padding: "12px",
                                    borderRadius: "6px",
                                    marginBottom: "15px",
                                  }}
                                >
                                  {/* 🔥 Header with Name + Switch */}
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <h5
                                      style={{
                                        margin: 0,
                                        textTransform: "uppercase",
                                      }}
                                    >
                                      {platform}
                                    </h5>

                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                      }}
                                    >
                                      <span>Enabled</span>
                                      <Switch
                                        size="small"
                                        checked={data.enabled}
                                        onChange={(checked) =>
                                          setFormData({
                                            ...formData,
                                            [platform]: {
                                              ...data,
                                              enabled: checked,
                                            },
                                          })
                                        }
                                      />
                                    </div>
                                  </div>

                                  {/* 🔹 TITLE */}
                                  <div style={{ marginBottom: "10px" }}>
                                    <label>Title</label>
                                    <Input
                                      value={data.title}
                                      maxLength={limits.title}
                                      onChange={(e) =>
                                        setFormData({
                                          ...formData,
                                          [platform]: {
                                            ...data,
                                            title: e.target.value,
                                          },
                                        })
                                      }
                                    />
                                    <div
                                      style={{
                                        fontSize: "12px",
                                        textAlign: "right",
                                        color:
                                          (data.title?.length || 0) >=
                                          limits.title
                                            ? "red"
                                            : "#666",
                                      }}
                                    >
                                      {data.title?.length || 0} / {limits.title}
                                    </div>
                                  </div>

                                  {/* 🔹 DESCRIPTION */}
                                  <div style={{ marginBottom: "10px" }}>
                                    <label>Description</label>
                                    <Input.TextArea
                                      value={data.description}
                                      maxLength={limits.description}
                                      rows={3}
                                      onChange={(e) =>
                                        setFormData({
                                          ...formData,
                                          [platform]: {
                                            ...data,
                                            description: e.target.value,
                                          },
                                        })
                                      }
                                    />
                                    <div
                                      style={{
                                        fontSize: "12px",
                                        textAlign: "right",
                                        color:
                                          (data.description?.length || 0) >=
                                          limits.description
                                            ? "red"
                                            : "#666",
                                      }}
                                    >
                                      {data.description?.length || 0} /{" "}
                                      {limits.description}
                                    </div>
                                  </div>

                                  {/* 🔹 EMBED URL */}
                                  <div>
                                    <label>Embed Url</label>
                                    <Input
                                      value={data.embedUrl}
                                      maxLength={limits.embedUrl}
                                      onChange={(e) =>
                                        setFormData({
                                          ...formData,
                                          [platform]: {
                                            ...data,
                                            embedUrl: e.target.value,
                                          },
                                        })
                                      }
                                    />
                                  </div>
                                </div>
                              );
                            }
                          )}
                        </>
                      )}

                      {activeSection === "titleSection" &&
                        Object.keys(formData || {}).map((key) => {
                          const maxLength =
                            key === "title"
                              ? 45
                              : key === "subtitle"
                              ? 85
                              : null;
                          const value = formData[key] || "";
                          const isLimitReached =
                            maxLength && value.length >= maxLength;

                          return (
                            <div key={key} style={{ marginBottom: "12px" }}>
                              <label style={{ fontWeight: 500 }}>
                                {key.charAt(0).toUpperCase() + key.slice(1)}
                              </label>

                              <Input
                                value={value}
                                maxLength={maxLength} // ✅ restrict input
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    [key]: e.target.value,
                                  })
                                }
                              />

                              {/* Character Counter */}
                              {maxLength && (
                                <div
                                  style={{
                                    fontSize: "12px",
                                    marginTop: "4px",
                                    gap: "8px",
                                    color: isLimitReached ? "red" : "#666",
                                    textAlign: "right",
                                  }}
                                >
                                  <span>Characters count</span> <span></span>
                                  <span>
                                    {value.length}/{maxLength}
                                  </span>
                                </div>
                              )}
                            </div>
                          );
                        })}

                      {activeSection === "featureCards" && (
                        <>
                          {formData?.map((item, index) => (
                            <div
                              key={index}
                              style={{
                                marginBottom: "15px",
                                border: "1px solid #ddd",
                                padding: "10px",
                                borderRadius: "6px",
                              }}
                            >
                              {Object.keys(item).map((key) => (
                                <div key={key} style={{ marginBottom: "8px" }}>
                                  <label style={{ fontWeight: 500 }}>
                                    {key.charAt(0).toUpperCase() + key.slice(1)}
                                  </label>

                                  <Input
                                    value={item[key]}
                                    onChange={(e) => {
                                      const updated = [...formData];
                                      updated[index][key] = e.target.value;
                                      setFormData(updated);
                                    }}
                                  />
                                </div>
                              ))}
                            </div>
                          ))}
                        </>
                      )}

                      {activeSection === "carousel" && (
                        <>
                          <div
                            style={{
                              display: "flex",
                              gap: "10px",
                              marginBottom: "15px",
                            }}
                          >
                            {formData?.map((_, index) => (
                              <button
                                key={index}
                                onClick={() => setActiveTabCarosuel(index)}
                                style={{
                                  padding: "6px 12px",
                                  borderRadius: "4px",
                                  border:
                                    activeTabCarosuel === index
                                      ? "2px solid #1890ff"
                                      : "1px solid #ccc",
                                  background:
                                    activeTabCarosuel === index
                                      ? "#e6f7ff"
                                      : "#fff",
                                  cursor: "pointer",
                                }}
                              >
                                Slide {index + 1}
                              </button>
                            ))}
                            <button
                              onClick={() => {
                                if (activeTabCarosuel === 0) return;
                                const updated = [...formData];
                                [
                                  updated[activeTabCarosuel - 1],
                                  updated[activeTabCarosuel],
                                ] = [
                                  updated[activeTabCarosuel],
                                  updated[activeTabCarosuel - 1],
                                ];
                                setFormData(updated);
                                setActiveTabCarosuel(activeTabCarosuel - 1);
                              }}
                            >
                              ↑ order change
                            </button>

                            <button
                              onClick={() => {
                                if (activeTabCarosuel === formData.length - 1)
                                  return;
                                const updated = [...formData];
                                [
                                  updated[activeTabCarosuel + 1],
                                  updated[activeTabCarosuel],
                                ] = [
                                  updated[activeTabCarosuel],
                                  updated[activeTabCarosuel + 1],
                                ];
                                setFormData(updated);
                                setActiveTabCarosuel(activeTabCarosuel + 1);
                              }}
                            >
                              ↓
                            </button>
                          </div>

                          {item && (
                            <div
                              style={{
                                border: "1px solid #ddd",
                                padding: "12px",
                                borderRadius: "6px",
                              }}
                            >
                              {Object.keys(item).map((key) => (
                                <div key={key} style={{ marginBottom: "10px" }}>
                                  <label style={{ fontWeight: 500 }}>
                                    {key.charAt(0).toUpperCase() + key.slice(1)}
                                  </label>

                                  {/* IMAGE */}
                                  {key === "image" ? (
                                    <>
                                      {item.image && (
                                        <img
                                          src={item.image}
                                          style={{
                                            borderRadius: "6px",
                                            marginBottom: "8px",
                                          }}
                                        />
                                      )}
                                      <input
                                        type="file"
                                        accept="image/*"
                                        onChange={(e) =>
                                          handleImageUpload(e, {
                                            section: "carousel",
                                            index: activeTabCarosuel,
                                            key: "image",
                                          })
                                        }
                                      />

<h6 className="mt-2">
                            ImgeSize is less then 2.MB only{" "}
                          </h6>
                                    </>
                                  ) : (
                                    <>
                                      <Input
                                        value={item[key]}
                                        maxLength={limits[key]}
                                        onChange={(e) => {
                                          const updated = [...formData];
                                          updated[activeTabCarosuel][key] =
                                            e.target.value;
                                          setFormData(updated);
                                        }}
                                      />

                                      {limits[key] && (
                                        <div
                                          style={{
                                            fontSize: "12px",
                                            textAlign: "right",
                                            color:
                                              item[key]?.length >= limits[key]
                                                ? "red"
                                                : "#666",
                                          }}
                                        >
                                          {item[key]?.length || 0} /{" "}
                                          {limits[key]}
                                        </div>
                                      )}
                                    </>
                                  )}
                                </div>
                              ))}
                            </div>
                          )}
                        </>
                      )}

                      {activeSection === "card" && formData && (
                        <>
                          {/* TITLE */}
                          <div style={{ marginBottom: "10px" }}>
                            <label>Title</label>
                            <Input
                              value={formData.title}
                              maxLength={30}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  title: e.target.value,
                                })
                              }
                            />

                            <div
                              style={{
                                fontSize: "12px",
                                textAlign: "right",
                                color:
                                  formData.title?.length >= 30 ? "red" : "#666",
                              }}
                            >
                              {formData.title?.length || 0} / 30 characters
                            </div>
                          </div>

                          {/* DESCRIPTION */}
                          <div style={{ marginBottom: "10px" }}>
                            <label>Description</label>
                            <Input.TextArea
                              value={formData.description}
                              maxLength={120}
                              rows={3}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  description: e.target.value,
                                })
                              }
                            />

                            <div
                              style={{
                                fontSize: "12px",
                                textAlign: "right",
                                color:
                                  formData.description?.length >= 120
                                    ? "red"
                                    : "#666",
                              }}
                            >
                              {formData.description?.length || 0} / 120
                              characters
                            </div>
                          </div>

                          {/* IMAGE */}
                          {formData.image && (
                            <img
                              src={formData.image}
                              alt="preview"
                              style={{
                                borderRadius: "6px",
                                marginBottom: "8px",
                              }}
                            />
                          )}

                          <input
                            type="file"
                            accept="image/*"
                            onChange={(e) =>
                              handleImageUpload(e, {
                                section: "cards",
                                index: activeIndex,
                              })
                            }
                          />

<h6 className="mt-2">
                            ImgeSize is less then 2.MB only{" "}
                          </h6>

                          {/* LINK */}
                          <div style={{ marginTop: "10px" }}>
                            <label>Link</label>
                            <Input
                              value={formData.link}
                              maxLength={200} // optional
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  link: e.target.value,
                                })
                              }
                            />
                          </div>
                        </>
                      )}

                      <div style={{ display: "flex", gap: 10, marginTop: 15 }}>
                        <Button
                          type="primary"
                          block
                          onClick={(e) => {
                            e.preventDefault();
                            handleSave();
                          }}
                        >
                          Save
                        </Button>
                        <Button block onClick={() => setIsDrawerOpen(false)}>
                          Cancel
                        </Button>
                      </div>
                    </Drawer>
                  </div>
                </>
              )}
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default IbizLoginPage;
